import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

import { NAME_REGEX } from 'src/app/constants/internationalized-constants-en'
import { equalsIgnoreCase } from 'src/app/utils/utils'

export class LabelEditDataModel {
  names?: string[]
  name?: string
  title?: string
}

export class LabelEditErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl) {
    return control && (control.touched || control.dirty) && control.invalid
  }
}

export function duplicateNameValidator(nameList: string[]): ValidatorFn {
  return (control: AbstractControl) => {
    const name: string = control.value
    return nameList && equalsIgnoreCase(nameList, name) ? { duplicateName: true } : null
  }
}

@Component({
  selector: 'app-label-edit-dialog',
  templateUrl: './label-edit-dialog.component.html',
  styleUrls: ['./label-edit-dialog.component.scss']
})
export class LabelEditDialogComponent implements OnInit, AfterViewInit {
  editForm: FormGroup

  matcher = new LabelEditErrorStateMatcher()

  title: string

  @ViewChild('labelInput', { read: ElementRef }) labelInput: ElementRef<HTMLElement>

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LabelEditDataModel,
    public dialogRef: MatDialogRef<LabelEditDialogComponent>
  ) {
    if (data) {
      if (data.title) {
        this.title = data.title
      }

      this.editForm = new FormGroup({
        label: new FormControl(data.name, [
          Validators.required,
          Validators.pattern(NAME_REGEX),
          duplicateNameValidator(data.names)
        ])
      })
    }
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.labelInput) {
      setTimeout(() => this.labelInput.nativeElement.focus(), 50)
    }
  }

  handleApply() {
    if (this.editForm.invalid) {
      return
    }

    this.dialogRef.close(this.editForm.value)
  }
}
